import logoImage from "../../assets/images/logoTopTecnologiaLoginPage.png";
import { Content, LogoImage } from "./styles";

function PreloadFb() {
    return (
        <Content>
            <LogoImage src={logoImage} alt="Top Tecnologia" />
        </Content>
    );
}

export default PreloadFb;
